import { useRef } from 'react';
import {
    Container,
    IconContainer,
    SearchInput
} from './SearchBar.styles';

export interface SearchBarProps {
    value: string;
    onChange: (value: string) => void;
    placeholder: string;
}

const SearchBar = ({ value, onChange, placeholder }: SearchBarProps) => {
    const searchInputRef = useRef<HTMLInputElement>(null);
    return (
        <Container>
            <IconContainer>
                <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M15.7075 14.7971L12.6107 11.699C14.9279 8.60247 14.296 4.2138 11.1995 1.89666C8.10302 -0.420492 3.71435 0.211319 1.3972 3.30783C-0.919942 6.40435 -0.288132 10.793 2.80838 13.1102C5.29576 14.9715 8.71212 14.9715 11.1995 13.1102L14.2976 16.2082C14.6869 16.5976 15.3182 16.5976 15.7074 16.2082C16.0968 15.8189 16.0968 15.1877 15.7074 14.7984L15.7075 14.7971ZM7.02978 12.5122C4.27774 12.5122 2.0468 10.2813 2.0468 7.52923C2.0468 4.77719 4.27774 2.54625 7.02978 2.54625C9.78181 2.54625 12.0128 4.77719 12.0128 7.52923C12.0098 10.28 9.7806 12.5093 7.02978 12.5122Z" fill="#9CA3AF" />
                </svg>
            </IconContainer>
            <SearchInput
                value={value}
                onChange={(e) => onChange(e.target.value)}
                type="text"
                placeholder={placeholder}
                ref={searchInputRef}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' || e.key === 'Tab') {
                        e.preventDefault();
                        searchInputRef.current?.blur();
                    }
                }}
            />
        </Container>
    );
};

export default SearchBar;
